import moment from "moment";

export function getVirtualTripInterval(item) {
  if (!item.isSubTrip || !item.completed || typeof item.parkedTime !== "string") return null;
  const duration = /^(?:(\d+)\.)?(\d+):(\d{2}):(\d{2})(?:\.(\d+))?$/.exec(item.parkedTime);
  if (!duration || Number(duration[3]) > 59 || Number(duration[4]) > 59) return null;
  const seconds = Number(duration[1] || 0) * 86400 + Number(duration[2]) * 3600 + Number(duration[3]) * 60 + Number(duration[4]) + Number(`0.${duration[5] || 0}`);
  // Match the existing report date formatter for both offset and unzoned values.
  const start = moment(item.completed);
  if (!start.isValid() || start.year() <= 1 || seconds <= 0) return null;
  return { start: start.toISOString(), end: start.clone().add(seconds, "seconds").toISOString() };
}
